import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormControl,
  FormControlStatus,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';

import { COUNTRY_CODES } from '@shared/constants/PHONE_NUMBER_CODES';
import { ICountryCode } from '@shared/constants/PHONE_NUMBER_CODES';
import { CommonModule } from '@angular/common';
import { PmButtonComponent } from '@shared/components/pm-button/pm-button.component';
import { PmFormFieldTextComponent } from '../pm-form-field-text/pm-form-field-text.component';
import { IFormFieldConfig } from '../../models/formConfig.model';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { PmFormFieldNumberComponent } from '../pm-form-field-number/pm-form-field-number.component';
import { SelectModule } from 'primeng/select';
@Component({
  standalone: true,
  selector: 'pm-form-field-phone',
  imports: [
    ReactiveFormsModule,
    SelectModule,
    FormsModule,
    CommonModule,
    PmButtonComponent,
    PmFormFieldTextComponent,
    PmFormFieldNumberComponent,
  ],
  templateUrl: './pm-form-field-phone.component.html',
  styleUrls: ['./pm-form-field-phone.component.scss'],
})
export class PmFormFieldPhoneComponent
  extends FormFieldComponent
  implements OnInit, OnDestroy
{
  @ViewChild('phoneNumberInput', { read: ElementRef })
  phoneNumberInput!: ElementRef;
  private subscriptions = new Subscription();
  countries: ICountryCode[] = [...COUNTRY_CODES];
  filteredCountries: ICountryCode[] = [...this.countries];
  selectedCountry: ICountryCode | null = null;
  filterCtrl = new FormControl();
  filterConfig: IFormFieldConfig = {
    name: 'filter',
    type: this.FormFieldTypeEnum.TEXT,
    label: '',
  };
  phoneCtrl!: FormControl;
  phoneConfig: IFormFieldConfig = {
    name: 'phone',
    type: this.FormFieldTypeEnum.TEXT,
    label: '',
  };

  ngOnInit(): void {
    this.phoneCtrl = new FormControl();
    this.initValues();
    const sub = this.filterCtrl.valueChanges
      .pipe(
        tap((val) => {
          this.filteredCountries = this.countries.filter(
            (c) =>
              c.names?.[this.CURRENT_LANGUAGE]
                ?.toLowerCase()
                ?.includes(val.toLowerCase()) ||
              c.dial_code?.toLowerCase()?.includes(val?.toLowerCase())
          );
        })
      )
      .subscribe();

    const phoneCtrlValueChanges = this.phoneCtrl.valueChanges
      .pipe(
        debounceTime(500),
        tap((val) => {
          console.log(val);
        }),
        tap(() => {
          this.setValue();
        })
      )
      .subscribe();

    const invalidInputSub = this.ctrl.statusChanges
      .pipe(
        distinctUntilChanged(),
        tap((status) => {
          this.setInputValidClass(status);
        })
      )
      .subscribe();

    this.subscriptions.add(phoneCtrlValueChanges);
    this.subscriptions.add(sub);
    this.subscriptions.add(invalidInputSub);
  }

  initValues() {
    if (this.ctrl.value) {
      const selectedCountry = this.countries.find((c) =>
        String(this.ctrl.value).startsWith(c.dial_code)
      );
      if (selectedCountry) {
        this.selectedCountry = selectedCountry;
        const phoneValue = String(this.ctrl.value).split(
          this.selectedCountry.dial_code
        )?.[1];

        this.phoneCtrl.setValue(phoneValue, { emitEvent: true });
        this.phoneCtrl.markAsTouched();
      }
    } else {
      this.phoneCtrl.setValue(this.ctrl.value, { emitEvent: true });
      this.phoneCtrl.markAsTouched();
      const defaultCountry = this.countries.find(
        (c) => c?.code?.toLowerCase() === this?.CURRENT_LANGUAGE?.toLowerCase()
      );
      if (defaultCountry) {
        this.selectedCountry = defaultCountry;
      }
    }
  }

  onSelectedCountryChange() {
    this.setValue();
  }

  setValue() {
    if (this.phoneCtrl.value) {
      this.ctrl.setValue(
        `${this.selectedCountry?.dial_code}${this.phoneCtrl.value}`,
        {
          emitEvent: true,
        }
      );
      this.ctrl.markAsDirty();
    } else {
      this.ctrl.setValue(null, { emitEvent: true });
      this.ctrl.markAsDirty();
    }
  }

  setInputValidClass(status: FormControlStatus) {
    const numberInput = this.phoneNumberInput.nativeElement
      .firstChild as HTMLElement;
    if (status === 'VALID') {
      numberInput.classList.remove('ng-invalid', 'ng-dirty', 'ng-touched');
      numberInput.classList.add('ng-valid');
    } else if (status === 'INVALID') {
      numberInput.classList.add('ng-invalid', 'ng-dirty', 'ng-touched');
      numberInput.classList.remove('ng-valid');
    }
  }

  resetFunction() {
    this.filteredCountries = [...this.countries];
    this.filterCtrl.reset();
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
